import { render, staticRenderFns } from "./NbNewUploadedFile.vue?vue&type=template&id=ebc47e26&lang=pug"
import script from "./NbNewUploadedFile.vue?vue&type=script&lang=ts"
export * from "./NbNewUploadedFile.vue?vue&type=script&lang=ts"
import style0 from "./NbNewUploadedFile.vue?vue&type=style&index=0&id=ebc47e26&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports